import { Button, Col, Row } from "antd";
import "./Order_Overview.css";
import React, { useContext, useEffect, useState } from "react";
import CheckoutStepFormContext from "../CheckoutStepFormContext";
import Light_Gray_Outline_Btn from "../../../common-components/common_btn/gray_outline_btn/Light_Gray_Outline_Btn";
import Green_Outline_Btn from "../../../common-components/common_btn/green_outline_btn/Green_Outline_Btn";
import Increment_decrement_btn_holder from "../../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartShopping,
  faTags,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { Form, InputGroup, Table } from "react-bootstrap";
import Order_Overview_summery_holder from "./order_Overview_summery_holder/Order_Overview_summery_holder";
import { Link, useNavigate } from "react-router-dom";
import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";
import Coupons_Modal from "../../../common-components/common_modal/coupons_modal/Coupons_Modal";
import { useDispatch, useSelector } from "react-redux";
import { deleteAllCart, getAllCart } from "../../../../features/cart/cartSlice";
import {
  CouponApplyed,
  createOrder,
  getSingleOrderAddress,
  OrderCalculation,
  OrderResponse,
} from "../../../../features/order/orderSlice";
import useRazorpay from "react-razorpay";
import { useForm } from "react-hook-form";
import Delete_Modal from "../../../common-components/common_modal/delete_modal/Delete_Modal";
import Spinner from "react-bootstrap/Spinner";
import { RolesIds, variant_type } from "../../../../utils/common";

const REDIRECT_SECONDS = 5;
const Order_Overview = ({ paymentValue, selectedAddressId }) => {
  const [modalDeleteShow, setModalDeleteShow] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const OkayData = {
    order_summary: {
      no_of_item: 0,
      total_mrp: 0,
      total_selling_price: 0,
      total_tax: 0,
      total_delivery_charges: 0,
      total_offer_discount: 0,
      total_coupon_discount: 0,
      refer_discount: 0,
      total_amount: 0,
      delivery_kilometer: 0,
      coupon_applied: false,
      exchange_rate: 1,
    },
  };

  const [data, setData] = useState({});
  const { prev } = useContext(CheckoutStepFormContext);
  const navigate = useNavigate();

  const handleClick = () => {
    setModalShow(true); // Show modal

    setTimeout(() => {
      setModalShow(false); // Close modal after 3s (optional)
      navigate("/"); // Navigate after modal
    }, 3000); // Show for 3 seconds
  };

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  const user = useSelector((state) => state.myaccount.addMyaccount);
  const isVendor =
    user?.role_id && Number(user?.role_id) === Number(RolesIds.Vendor);

  const [CouponData, setCouponData] = React.useState("");

  const [Errors, setErrors] = React.useState(null);
  const [loader, setLoader] = useState(false);

  const isSignin = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();
  const allcartData = useSelector((state) => state.cart.allCarts);
  useEffect(() => {
    dispatch(getAllCart(isSignin));
  }, [dispatch]);

  const [countdown, setCountdown] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    if (!Errors) {
      setCountdown(REDIRECT_SECONDS);
      return;
    }
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [Errors]);

  useEffect(() => {
    if (Errors && countdown <= 0) {
      navigate("/product-cart");
    }
  }, [Errors, countdown, navigate]);

  const orderCalculation = async (selectedAddressId, currentCurrency) => {
    setLoader(true);

    const data = {
      address_id: selectedAddressId,
      exchange_rate: currentCurrency?.rate,
    };

    if (CouponData) {
      data.coupon_id = CouponData?.id;
    }
    const res = await dispatch(OrderCalculation(data));
    console.log({ resresres: res });

    if (res.meta?.requestStatus === "fulfilled") {
      setData(res.payload.data);
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.errors) {
        setErrors(res.payload?.errors);
      }
      setData(OkayData);
    }
    await setLoader(false);
  };

  useEffect(() => {
    orderCalculation(selectedAddressId, currentCurrency);
  }, [selectedAddressId, CouponData, currentCurrency]);

  const address = useSelector((state) => state.order.orderAddress);
  useEffect(() => {
    dispatch(getSingleOrderAddress({ id: selectedAddressId }));
  }, [dispatch, selectedAddressId]);

  //order place
  const [razorid, setRazorId] = useState();
  const [Razorpay] = useRazorpay();
  const handleRazorpay = async (price) => {
    const amountInPaise = Math.round(price * 100);
    const options = {
      // key: "rzp_test_I05KCFb1v5JJRc",
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "RED LOTTUS",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        await setRazorId(res.razorpay_payment_id);
        finalFunction(res.razorpay_payment_id);
      },
      prefill: {
        name: "Piyush Garg",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  const finalFunction = async (payment_id) => {
    setLoader(true);

    const datafinal = {
      exchange_rate_id: currentCurrency?.id,
      exchange_rate: currentCurrency?.rate,
      address_id: selectedAddressId,
      payment_method_id: paymentValue,
      order_summary: data?.order_summary,
      order_Details_summary: data?.order_Details_summary,
    };
    if (payment_id) {
      datafinal.payment_id = payment_id;
    }

    const res = await dispatch(createOrder(datafinal));

    if (res.meta?.requestStatus === "fulfilled") {
      const redirectUrl = res?.payload?.data?.redirectUrl;

      // ✅ 🔥 PHONEPE REDIRECT
      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }

      // ✅ For COD / Wallet
      handleClick();
      await dispatch(getAllCart(isSignin));
    } else if (res.meta?.requestStatus === "rejected") {
      setErrors(res.payload);

      await dispatch(getAllCart(isSignin));

      // setTimeout(() => {
      //   navigate("/product-cart");
      // }, 5000);
      console.log("Order failed");
    }

    setLoader(false);
  };
  // const finalFunction = async (razorpay) => {
  //   setLoader(true);
  //   const datafinal = {
  //     exchange_rate_id: currentCurrency?.id,
  //     exchange_rate: currentCurrency?.rate,
  //     address_id: selectedAddressId,
  //     payment_method_id: paymentValue,
  //     order_summary: data?.order_summary,
  //     order_Details_summary: data?.order_Details_summary,
  //   };
  //   if (razorpay) {
  //     datafinal.payment_id = razorpay;
  //   }

  //   const res = await dispatch(createOrder(datafinal));

  //   if (res.meta?.requestStatus === "fulfilled") {
  //     handleClick();
  //     await dispatch(getAllCart(isSignin));
  //   } else if (res.meta?.requestStatus === "rejected") {
  //     // if (res.payload?.errors?.email) {
  //     //     setError("email", {
  //     //       type: "manual",
  //     //       message: res.payload?.errors?.email,
  //     //     });
  //     //   }
  //   }
  //   setLoader(false);
  // };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (dataSubmit) => {
    const DataToSend = new FormData();
    DataToSend.append("code", dataSubmit?.code);
    DataToSend.append("amount", data?.order_summary?.total_selling_price);

    const res = await dispatch(CouponApplyed(DataToSend));

    if (res?.payload?.data) {
      setCouponData(res?.payload?.data);
      setValue("code", res?.payload?.data?.code);
      setShowCouponModal(false);
    }
    if (res?.payload?.errors) {
      setModalDeleteShow(res?.payload?.errors);
      // setError("code", {
      //   type: "manual",
      //   message: res.payload?.errors,
      // });
    }
  };

  const deleteCart = async (id, product_id, varient_id) => {
    try {
      const res = await dispatch(
        deleteAllCart({ id, isSignin, product_id, varient_id }),
      );
      console.log({ resresresresresresres: res });

      if (res.meta?.requestStatus === "fulfilled") {
        await dispatch(getAllCart(isSignin));
        await orderCalculation(selectedAddressId);
      } else if (res.meta?.requestStatus === "rejected") {
        await orderCalculation(selectedAddressId);
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {}
  };
  // useEffect(() => {
  //   if (allcartData?.data?.length <= 0) {
  //     navigate("/categories");
  //   }
  // }, [allcartData?.data?.length]);

  return (
    <>
      <div className={"Cart_Products_card Order_Overview"}>
        {allcartData?.data?.length > 0 ? (
          <div className="row g-4">
            <div className="col-lg-7 col-md-12">
              <div className="oo_card">
                <div className="oo_card_head">
                  <h4>Order Items</h4>
                  <span className="oo_count">
                    {allcartData?.data?.length}{" "}
                    {allcartData?.data?.length === 1 ? "Item" : "Items"}
                  </span>
                </div>

                <div className="all_records">
                  {allcartData?.data?.map((val) => {
                    const offerDiscount =
                      Number(
                        data?.order_Details_summary?.find(
                          (d) => d?.cart_id === val?.id,
                        )?.offer_discount || 0,
                      ) * rate;
                    return (
                      <div className="oo_item" key={val?.id}>
                        <div className="img_holder">
                          <img
                            className="Product_img"
                            src={
                              process.env.REACT_APP_IMG_URL + val.Product?.image
                            }
                            alt={"Product_img"}
                          />
                        </div>

                        <div className="info_text_holder">
                          <h4>{val.Product?.name}</h4>

                          <div className="oo_variants">
                            {val?.Product?.variant_type_id ===
                              variant_type.Single && (
                              <span className="oo_chip">
                                <strong>Size:</strong>{" "}
                                {val?.Product_Variant?.Metal?.name}
                              </span>
                            )}

                            {val?.Product?.variant_type_id ===
                              variant_type.Double && (
                              <>
                                <span className="oo_chip">
                                  <strong>Metal:</strong>{" "}
                                  {
                                    val?.Double_Variant?.Product_Variant?.Metal
                                      ?.name
                                  }
                                </span>
                                <span className="oo_chip">
                                  <strong>Size:</strong>{" "}
                                  {val?.Double_Variant?.Size?.name}
                                </span>
                              </>
                            )}

                            {val?.Product?.variant_type_id ===
                              variant_type.Triple && (
                              <>
                                <span className="oo_chip">
                                  <strong>Metal:</strong>{" "}
                                  {
                                    val?.Triple_Variant?.Double_Variant
                                      ?.Product_Variant?.Metal?.name
                                  }
                                </span>
                                <span className="oo_chip">
                                  <strong>Size:</strong>{" "}
                                  {
                                    val?.Triple_Variant?.Double_Variant?.Size
                                      ?.name
                                  }
                                </span>
                                <span className="oo_chip">
                                  <strong>Diamond:</strong>{" "}
                                  {val?.Triple_Variant?.Diamond?.name}
                                </span>
                              </>
                            )}
                          </div>

                          <div className="oo_meta">
                            {isVendor ? (
                              <p className="sale_price">
                                ₹
                                {Number(
                                  Number(
                                    val.Triple_Variant?.b2b_price ||
                                      val.Double_Variant?.b2b_price ||
                                      val.Product_Variant?.b2b_price,
                                  ) * rate,
                                ).toFixed(2)}
                              </p>
                            ) : (
                              <p className="sale_price">
                                ₹
                                {Number(
                                  Number(
                                    val.Triple_Variant?.price ||
                                      val.Double_Variant?.price ||
                                      val.Product_Variant?.price,
                                  ) * rate,
                                ).toFixed(2)}
                                <span>
                                  ₹
                                  {Number(
                                    Number(
                                      val.Triple_Variant?.mrp ||
                                        val.Double_Variant?.mrp ||
                                        val.Product_Variant?.mrp,
                                    ) * rate,
                                  ).toFixed(2)}
                                </span>
                              </p>
                            )}
                            <span className="oo_qty">Qty: {val?.quantity}</span>
                          </div>
                        </div>

                        <div className="Quantity_tr_holder">
                          <button
                            type="button"
                            className="trash_btn"
                            title="Remove item"
                            onClick={() =>
                              deleteCart(
                                val?.id,
                                val?.product_id,
                                val?.variant_id,
                              )
                            }
                          >
                            <FontAwesomeIcon
                              className="trash_icon"
                              icon={faTrashCan}
                            />
                          </button>

                          <div className="price_holder">
                            <small className="total_label">Total</small>
                            {isVendor ? (
                              <p className="mb-0">
                                ₹
                                {(
                                  Number(
                                    val.Product_Variant?.b2b_price ||
                                      val.Double_Variant?.b2b_price ||
                                      val.Triple_Variant?.b2b_price,
                                  ) *
                                  rate *
                                  Number(val.quantity)
                                ).toFixed(2)}
                              </p>
                            ) : (
                              <p className="mb-0">
                                ₹
                                {(
                                  Number(
                                    val.Product_Variant?.price ||
                                      val.Double_Variant?.price ||
                                      val.Triple_Variant?.price,
                                  ) *
                                  rate *
                                  Number(val.quantity)
                                ).toFixed(2)}
                              </p>
                            )}
                            {offerDiscount > 0 && (
                              <small className="offer_discount">
                                Offer discount: -₹
                                {Number(offerDiscount).toFixed(2)}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-md-12">
              <div className="oo_side">
                <div className="oo_card oo_summary_card">
                  {/* <div className="oo_card_head">
                    <h4>Order Summary</h4>
                  </div> */}
                  <Order_Overview_summery_holder
                    data={data}
                    address={address}
                    paymentValue={paymentValue}
                  />
                </div>

                {Errors && (
                  <div className="oo_error">
                    {Errors}
                    <div>
                      Redirecting to cart page in {Math.max(countdown, 0)}{" "}
                      seconds...
                    </div>
                  </div>
                )}

                <div className="oo_card Rewards_text_holder">
                  <h4>Offers and Rewards</h4>
                  <Form>
                    <InputGroup>
                      <InputGroup.Text
                        className="tags_icon_holder"
                        id="basic-addon2"
                      >
                        <FontAwesomeIcon className="tags_icon" icon={faTags} />
                      </InputGroup.Text>

                      <Form.Control
                        className="mb-0"
                        placeholder="Enter Coupon Code"
                        {...register("code", {
                          required: "Coupon code is required",
                        })}
                        readOnly={!!CouponData}
                        disabled
                      />

                      {CouponData ? (
                        <InputGroup.Text
                          as="button"
                          type="submit"
                          className="view_grp"
                          id="basic-addon2"
                          onClick={() => {
                            setCouponData("");
                            setValue("code", "");
                          }}
                        >
                          Remove
                        </InputGroup.Text>
                      ) : (
                        <InputGroup.Text
                          className="view_grp"
                          id="basic-addon2"
                          onClick={() => setShowCouponModal(true)}
                        >
                          View
                        </InputGroup.Text>
                      )}
                    </InputGroup>
                  </Form>
                </div>

                {loader ? (
                  <div className="d-flex justify-content-center py-3">
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <div className="btn_holder">
                    <Green_Outline_Btn btnText={"Back"} onClick={prev} />
                    <Green_Outline_Btn
                      btnText={"Place Order"}
                      disabled={Errors}
                      onClick={() =>
                        paymentValue !== 2
                          ? finalFunction()
                          : handleRazorpay(data?.order_summary?.total_amount)
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="oo_empty">
            <div className="oo_empty_icon">
              <FontAwesomeIcon icon={faCartShopping} />
            </div>
            <h4>Your cart is empty</h4>
            <p>Looks like you haven't added anything yet.</p>
            <div className="btn_holder">
              {/* <Green_Outline_Btn btnText={"Back"} onClick={prev} /> */}
              <Green_Outline_Btn
                btnText={"Continue Shopping"}
                onClick={() => navigate("/categories")}
              />
            </div>
          </div>
        )}
      </div>

      <Success_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText="Your Order Has Been Placed Successfully!"
      />

      <Coupons_Modal
        setValue={setValue}
        setCouponData={setCouponData}
        onSubmit={onSubmit}
        data={data}
        show={showCouponModal}
        onHide={() => {
          setShowCouponModal(false);
        }}
      />

      <Delete_Modal
        show={modalDeleteShow}
        onHide={() => setModalDeleteShow(false)}
        successText={modalDeleteShow}
      />
    </>
  );
};
export default Order_Overview;
